import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import theme from '../../global/theme';

const Card = ({
  icon,
  title,
  count,
  bg = theme.light,
  iconBg = `${theme.primary}14`,
  iconColor = theme.primary,
  titleColor = theme.text,
  countColor = theme.dark,
  suffix = '',
}) => {
  return (
    <Box
      bg={bg}
      borderRadius="22px"
      border={`1px solid ${bg === theme.light ? theme.border : 'transparent'}`}
      boxShadow={theme.shadow}
      p={5}
      position="relative"
      overflow="hidden"
      transition="all 0.25s ease"
      _hover={{
        transform: 'translateY(-4px)',
        boxShadow: '0px 12px 32px rgba(82, 63, 105, 0.10)',
      }}
    >
      <Flex align="flex-start" justify="space-between" gap={4}>
        <Box flex="1">
          <Text
            color={titleColor}
            fontSize="14px"
            fontWeight="700"
            mb={2}
          >
            {title}
          </Text>

          <Text
            color={countColor}
            fontSize="26px"
            fontWeight="600"
          >
            {count}
            {suffix ? (
              <Text as="span" fontSize="18px" ms={1}>
                {suffix}
              </Text>
            ) : null}
          </Text>
        </Box>

        <Flex
          minW="54px"
          h="54px"
          borderRadius="18px"
          align="center"
          justify="center"
          bg={iconBg}
          color={iconColor}
          fontSize="22px"
          boxShadow="inset 0 0 0 1px rgba(255,255,255,0.08)"
        >
          {icon}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Card;